export function checkTouchDevice() {
  return 'ontouchstart' in window;
}
